import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { en, de, es, it, fr } from 'vuetify/es5/locale'

Vue.use(Vuetify)

export const vuetify = new Vuetify({
    lang: {
        locales: { de, en, es, it, fr },
        current: 'de',
    },
    theme: {
        themes: {
            light: {
                primary: '#2F2924',
                secondary: '#656971',
                accent: '#F49900',
                error: '#E60006',
                info: '#193CB8',
                success: '#00A63E',
                warning: '#E17100',
            },
        },
        options: { customProperties: false }, //customProperties break IE11 colors
    },
    icons: {
        iconfont: 'mdi',
    },
})

// see https://anice.red/#3b5998
// see https://coolors.co/3b5998-ced3dc-fcf7f8-ff8200-13293d
